export enum AvailabilityStatus {
  InProgress = 'inProgress',
  Available = 'available',
  Error = 'error',
}
